<template>
  <div class="upload-img" :class="{ 'upload-img-small': small }">
    <div class="el-upload-list--picture-card">
      <loader-wrapper :loading="loading">
        <div class="el-upload-list__item">
          <el-image :src="imageUrl ? imageUrl : ''" fit="contain">
            <i class="el-icon-zoom-in" />
            <div slot="error" class="image-slot" />
            <div slot="placeholder" class="image-slot" />
          </el-image>
          <span v-if="imageUrl" class="el-upload-list__item-actions">
            <span
              v-if="!isPdf"
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview"
            >
              <i class="el-icon-zoom-in" />
            </span>
            <span
              v-if="img"
              class="el-upload-list__item-delete"
              @click="handleDownload"
            >
              <i class="el-icon-download" />
            </span>
            <span
              v-if="!hardware"
              class="el-upload-list__item-delete"
              @click="handleRemove"
            >
              <i class="el-icon-delete" />
            </span>
          </span>
        </div>
      </loader-wrapper>
    </div>
    <el-upload
      v-if="!hardware"
      ref="uploadImg"
      action=""
      :auto-upload="false"
      :show-file-list="false"
      :on-change="handleChange"
    >
      <el-button
        slot="trigger"
        :size="small ? 'mini' : 'medium'"
        :type="text ? 'text' : 'primary'"
        :class="{ 'ttn-btn': true, 'ttn-btn-text': text }"
      >
        {{ small ? 'Выбрать файл' : 'Перейти к загрузке файлов' }}
      </el-button>
      <div v-if="!text" slot="tip" class="el-upload__tip">
        jpg/png{{ types.title || '' }} файлы размером не более 15МБ
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'UploadImg',
  components: { LoaderWrapper },
  props: {
    img: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
    types: {
      type: Object,
      default: () => Object(),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    hardware: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      isPdf: false,
      file: null,
      fileTypes: ['image/jpeg', 'image/png'],
      imagePDF: require('@/assets/img/pdf.png'),
    }
  },
  watch: {
    img: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isPdf = val.includes('.pdf')
          this.imageUrl = this.isPdf ? this.imagePDF : val
        } else {
          this.handleRemove()
        }
      },
    },
  },
  methods: {
    beforeUpload(file) {
      const types =
        this.types && this.types.format
          ? this.fileTypes.concat(this.types.format)
          : this.fileTypes
      const isFormat = types.includes(file.type)
      const isSize = file.size / 1024 / 1024 < 15

      if (!isFormat) {
        this.$message.error(
          'Ошибка при загрузке файла ' +
            file.name +
            ' попробуйте еще раз. Неверный формат',
        )
      }
      if (!isSize) {
        this.$message.error(
          'Ошибка при загрузке файла ' +
            file.name +
            ' попробуйте еще раз. Превышен размер. Допускаються файлы размером не более 15МБ',
        )
      }

      return isFormat && isSize
    },
    handleChange(file) {
      if (file.raw && this.beforeUpload(file.raw)) {
        this.isPdf = file.raw.type === 'application/pdf'
        this.imageUrl = this.isPdf
          ? this.imagePDF
          : URL.createObjectURL(file.raw)
        this.file = file.raw
        this.$emit('changed', file.raw)
      }
    },
    handleRemove() {
      if (this.$refs['uploadImg']) {
        this.$refs['uploadImg'].clearFiles()
      }
      this.imageUrl = ''
      this.isPdf = false
      this.$emit('changed', undefined)

      if (this.img) {
        if (this.id) {
          this.$emit('delete', this.id)
        } else {
          this.$emit('delete')
        }
      }
    },
    handleDownload() {
      this.downloadRegistry({ path: this.img, blank: 1 })
    },
    handlePictureCardPreview() {
      this.dialogImageUrl = this.imageUrl
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="sass">
.upload-img
  margin-right: 20px
  .el-upload-list--picture-card
    .el-upload-list__item
      border: 1px solid #000
      border-radius: 0
      width: 100%
      height: 318px
      margin: 0
    .el-image
      width: 100%
      height: 100%
      .image-slot:after
        content: ''
        position: absolute
        border: 1px solid #000000
        -webkit-transform: matrix(-0.65, 0.8, -0.8, -0.65, 0, 0)
        transform: matrix(0.65, 0.8, -0.85, 0.6, 0, 0)
        width: 400px
        top: 160px
        left: -70px
      .image-slot:before
        content: ''
        position: absolute
        border: 1px solid #000000
        -webkit-transform: matrix(-0.65, 0.8, -0.8, -0.65, 0, 0)
        transform: matrix(-0.65, 0.8, -0.8, -0.65, 0, 0)
        width: 400px
        top: 155px
        left: -70px

  &-small
    margin-right: 0

    & .ttn-btn
      font-size: 12px !important
      margin-top: 10px !important
    & .ttn-btn-text
      font-size: 12px !important
      margin-top: 3px !important
      margin-bottom: 8px !important
      padding: 0

    & .el-upload-list--picture-card
      & .el-upload-list__item
        height: 160px

        & .el-image
          & .image-slot:before
            width: 200px
            top: 78px
            left: -36px
</style>
